import type React from 'react';
import { useEffect } from 'react';
import Popup from 'reactjs-popup';
import { useApp } from '@/forApp/states/appState/appState';
import IconButton from '@/shared/Buttons/IconButton/IconButton';
import { Icons } from '@/shared/Icons/Icons';
import styles from './styles.module.css';

interface ModalProps {
  title?: string;
  description?: string;
  onClose?: () => void;
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({
  title,
  description,
  onClose,
  children,
}) => {
  const { delModal } = useApp();
  const onCloseModal = () => {
    if (onClose) onClose();
    delModal();
  };

  // Add modal-open class to body when modal is mounted and remove it when unmounted
  useEffect(() => {
    document.body.classList.add('modal-open');

    return () => {
      document.body.classList.remove('modal-open');
    };
  }, []);

  return (
    <Popup
      open={true}
      closeOnDocumentClick
      onClose={delModal}
      className="modal-popup"
    >
      <div className={styles.modalContainer}>
        <div className={styles.modalHeader}>
          <div className={styles.closeButtonContainer}>
            <IconButton
              ariaLabel="Закрыть"
              icon={<Icons.Close />}
              color={'default'}
              onClick={onCloseModal}
            />
          </div>
          <div className={styles.headerContent}>
            {title && <h4 className={styles.title}>{title}</h4>}
            {description && <p className={styles.description}>{description}</p>}
          </div>
        </div>
        <div className={styles.modalContent}>{children}</div>
      </div>
    </Popup>
  );
};

export default Modal;
